<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="addShop">添加店铺</el-button>
        <ImportDialog buttonName="导入店铺" fileName="导入店铺" fileType="crm_register_setting_distributor"
          @closeDialog="refresh"></ImportDialog>
        <el-button type="primary" @click="deleteShopItem">批量删除</el-button>
        <span class="float-right">Towmship开启购买注册<el-switch v-model="openStatus" active-color="#13ce66"
            inactive-color="#ff4949" @change="changeRegisterDistributor"></el-switch></span>
      </el-col>
    </el-row>
    <SpFinder ref="finder" row-key="item_id" :split-count="10" :url="table_url" row-actions-width="200" :setting="setting"
      reserve-selection @select="handleSelectChange" @select-all="handleSelectAll"
      :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }" />
  </div>
</template>
<script>
import ImportDialog from '@/components/importDialog'
import { shopTableSetting } from '../config'
import { shopList, batchDelete, registerDistributor, registerSettingCreate } from '../api'
export default {
  components: {
    ImportDialog
  },
  props: {
    orgData: Object
  },
  data() {
    return {
      table_url: shopList,
      tableData: [],
      openStatus: true
    }
  },
  computed: {
    setting() {
      return shopTableSetting(this)
    }
  },
  mounted() {

  },

  methods: {
    beforeSearch(params) {
      return {
        ...params,
        page_size: params.pageSize != null ? params.pageSize : params.page_size,
      }
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    handleSelectChange(data) {
      this.tableData = data
    },
    handleSelectAll(data) {
      this.tableData = data
    },
    // 添加店铺
    async addShop() {
      const { data } = await this.$picker.shop({
        data: this.tableData,
        multiple: true
      })
      const params = {
        rel_type: 'distributor',
        rel_ids: data.map(item => item.distributor_id)
      }
      await registerSettingCreate(params)
      this.$message.success('添加成功')
      this.refresh()
    },
    async deleteShopItem() {
      if (this.tableData.length === 0) {
        this.$message.error('请选择要删除的店铺')
        return
      }
      this.$confirm('请确认是否批量删除？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          let ids = this.tableData.map(item => item.id)
          await batchDelete({ ids })
          this.$message.success('删除成功')
          this.refresh()
        })
    },
    afterSearch(response) {
      const { open_status } = response.data.data
      this.openStatus = open_status

    },
    changeRegisterDistributor(val) {
      registerDistributor({ status: val })
    }
  }
};
</script>
<style scoped lang="scss">
.float-right {
  color: #1480e3;
  float: right;
}
</style>